export const commonurls = {
    websiteUrl: 'B2btravelagency.com',
    clientEmail: 'sales.india@b2btravelagency.com',
    refundMail: 'refund.india@b2btravelagency.com',
    refundInMail: 'refund.india@b2btravelagency.com',
    supportMail: 'support@b2btravelagency.com',
    apisupportMail:'apisupport@b2btravelagency.com',
    liveUrl: 'https://bta-app.bookotrip.com'
};